export default __webpack_public_path__ + "static/media/expandMenuIcon.7bed6692.svg";